import { Component, OnInit, Input,OnChanges, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import {FormGroup} from '@angular/forms'
import{LoopBackAuth, listadosService, userService, parienteService, matriculaService} from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';
import {ValidarIdentificacionDirective} from '../directive/validar-identificacion.directive'
import { ToastrService } from 'ngx-toastr';
import { isNull } from 'util';
@Component({
  selector: 'datos-factura',
  template: `
  <form name="form-inscripciones" [formGroup]="economico">
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
      Identificación: <span class="text-danger">*</span></label>
      <div class="col-sm-2 p-0">
        <div class="input-group input-group-sm">
            <select
            class="form-control"
            [style.border-radius]="'0px'"
            [style.height]="'28px'"
            formControlName="tipo"
            (change)="onChangeTipo($event.target.value); activarCampos() "
            >
            <option *ngFor="let item of identificaciones" [value]="item.id">{{item.descripcion | uppercase}}</option>
            </select>
        </div>
      </div>
      <div class="col-sm-2 p-0">
        <div
            class="input-group input-group-sm mb-0"
            [ngClass]="{'showError': !economico.get('identificacion').valid && economico.get('identificacion').touched}">
            <input
                type="text"
                class="form-control"
                [style.border-radius]="'0px'"
                maxlength="{{maxLongitud}}"
                minlength="{{minLongitud}}"
                formControlName="identificacion"
                validarIdentificacion="{{economico.get('tipo').value}}"
                (blur)="verificarIdentificacion()"
            >
        </div>
      </div>
      <label class="col-sm-2 col-form-label text-right">
      Email: <span class="text-danger">*</span></label>
      <div class="col-sm-4 pl-0">
        <div
            [ngClass]="{'showError': !economico.get('email').valid && economico.get('email').touched}"
            class="input-group input-group-sm">
            <input
                type="text"
                [style.border-radius]="'0px'"
                class="form-control"
                formControlName="email"
            >
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
        Razon social: <span class="text-danger">*</span></label>
      <div class="col-sm-4 p-0">
        <div
            [ngClass]="{'showError': !economico.get('razonSocial').valid && economico.get('razonSocial').touched}"
              class="input-group input-group-sm">
            <input
                type="text"
                [style.border-radius]="'0px'"
                class="form-control"
                formControlName="razonSocial"
                frmUppercase
            >
        </div>
      </div>
      <label class="col-sm-2 col-form-label text-right">
      Teléfono: <span class="text-danger">*</span></label>
      <div class="col-sm-4 pl-0">
        <div
            [ngClass]="{'showError': !economico.get('telefono').valid && economico.get('telefono').touched}"
              class="input-group input-group-sm">
            <input
                type="text"
                [style.border-radius]="'0px'"
                class="form-control"
                formControlName="telefono"
            >
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
      Dirección: <span class="text-danger">*</span></label>
      <div class="col-sm-10 pl-0">
        <div
            [ngClass]="{'showError': !economico.get('direccion').valid && economico.get('direccion').touched}"
              class="input-group input-group-sm">
            <input
                type="text"
                [style.border-radius]="'0px'"
                class="form-control"
                placeholder="Calle principal y calle secundaria"
                formControlName="direccion"
                frmUppercase
            >
        </div>
      </div>
    </div>
    <div class="row mt-2">
    <div class="col-12 d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-primary pb-1 pt-1"
          (click)="guardar()"
          [hidden]="preview">
            <i class="fas fa-save"></i> Guardar
        </button>
    </div>
  </div>
  </form>
  `,
  providers:[LoopBackAuth, listadosService, MessageService, userService, parienteService, matriculaService]
})

export class DatosFacturaComponent implements OnInit, OnChanges {
  @Input() idEstudiante: String
  @Input() idMatricula: String
  @Input() idEstado: String
  @Input() economico: FormGroup
  @Input() ingresaFactura: string
  @Input() preview: boolean = false
  @Input() esAdmin: boolean = false
  /** Salida */
  @Output() emitGuardarDatos  = new EventEmitter()

  public maxLongitud: number = 13
  public minLongitud: number = 10
  @ViewChild(ValidarIdentificacionDirective) validarIdentificacion: ValidarIdentificacionDirective


  public identificaciones:any[]
  constructor(
    private listadosService:listadosService,
    private userService:userService,
    private parienteService:parienteService,
    private toastr: ToastrService,
    private matriculaService:matriculaService
  ) { }

  ngOnInit() {
     /** Busco el listado de identificador por el tipo  */
     this.listadosService.identificaciones(4).subscribe(
      result=>{
        this.identificaciones = result
        this.onChangeTipo( this.economico.get('tipo').value)
        //this.activarCampos()
      }
    )
    if(this.preview) this.economico.disable()
  }

  ngOnChanges(changes:SimpleChanges) {
    /** Verifico si el campo ingresaFactura cambia */
    if(changes.ingresaFactura!= undefined && changes.ingresaFactura.currentValue != undefined){
      console.log("caambuos -->",changes.ingresaFactura.currentValue , changes.ingresaFactura.previousValue)
      if(changes.ingresaFactura.currentValue == "1000"){
        if(changes.ingresaFactura.previousValue != undefined)
          this.economico.get('tipo').setValue(1)
        this.activarCampos()
      }
      if(changes.ingresaFactura.currentValue != "1000") this.economico.disable()
    }

  }

  public verificarIdentificacion(){
    if(this.economico.get('identificacion').value.length > 9){
      this.parienteService.findIdentificacion(this.economico.get('identificacion').value,this.idEstudiante).subscribe(
        datos =>{
          if(!isNull(datos)){
            this.economico.patchValue(
              {
                id: datos.aca_parentesco_codigo,
                parentesco: (isNull(datos.aca_parentesco_tipo_id)) ? 1000 : datos.aca_parentesco_tipo_id,
                categoria:2,
                tipo: datos.tipo_identificacion_glb_identificacion_id,
                identificacion: datos.identificacion,
                email: datos.correo_electronico,
                apellido:datos.apellido,
                nombre:datos.nombre,
                direccion:datos.direccion,
                razonSocial: datos.nombre +' '+ datos.apellido,
                telefono: (!isNull(datos.telefonos)  && datos.telefonos.length > 0 ) ? datos.telefonos[0].telefono : ''
              }
            )
            this.onChangeTipo( this.economico.get('tipo').value)

          }else{
            this.economico.get('razonSocial').enable()
            this.economico.get('telefono').enable()
            /** Limpio los campos */
            this.economico.get('id').setValue(null)
            this.economico.get('parentesco').setValue(1000)
            this.economico.get('categoria').setValue(2)
            this.economico.get('nombre').setValue(null)
            this.economico.get('apellido').setValue('')
            this.economico.get('razonSocial').setValue('')
            this.economico.get('direccion').setValue(null)
            this.economico.get('telefono').setValue(null)
            this.economico.get('email').setValue('')

          }
        }
      )
    }

  }

  public onChangeTipo(event: any){
    console.log("Datos filtara", this.identificaciones)
    let tipo = this.identificaciones.filter((x:any)=> x.id == event)[0]
    this.maxLongitud = tipo.maximo
    this.minLongitud = tipo.minimo
    console.log("Maximo y minimo",this.maxLongitud,this.minLongitud)
  }

  public activarCampos(){
    if(this.ingresaFactura == "1000"){
      if(this.economico.get('tipo').value == 4 || isNull(this.economico.get('tipo').value )){
        this.economico.reset()
        this.economico.patchValue({
          identificacion:"9999999999999",
          tipo:4
        })

        this.userService.findIdentificacion(this.economico.get('identificacion').value).subscribe(
          usuario =>{
              console.log("Usuario -->", usuario)
              this.economico.patchValue({
                razonSocial: usuario.apellido + ' '+ usuario.nombre,
                email: usuario.correoElectronico,
                direccion: usuario.direccion,
                telefono:'999999999999'
              })
          }
        )

        this.economico.disable()
        if(!this.preview)
          this.economico.get('tipo').enable()
      }else{
        let tipo  = this.economico.get('tipo').value
        if(this.economico.get('identificacion').value == "9999999999999")
          this.economico.reset()
        this.economico.patchValue({
          tipo:tipo,
        })
        this.economico.enable()
      }
    }else{
      this.economico.disable()
    }
  }

  public validarFormulario(){
    //if(this.esAdmin) return true
    //if(this.ingresaFactura != "1000") return true
    let contador = 0
    let padre = this.economico as FormGroup
    Object.keys(padre.controls).forEach(field => {
      const control = this.economico.get(field)
      if(field == 'identificacion' && !isNull(this.validarIdentificacion.validate(control))){
        control.markAsTouched({ onlySelf: true })
        contador ++
      }
      if(!isNull(control.errors) ){
        control.markAsTouched({ onlySelf: true })
        contador ++
      }
    })
    return (contador > 0) ? false :true
  }

  public guardar(){
    if(!this.validarFormulario()){
      this.toastr.error("Falta campos de ingresar, deben estar pintados de color rojo","Pestaña Facturación")
      return null
    }

    if(this.ingresaFactura == '1000'){
      this.economico.get('nombre').setValue(this.economico.get('razonSocial').value)
      this.economico.get('apellido').setValue('')
    }

    this.parienteService.create(this.idEstudiante,this.economico.getRawValue()).subscribe(
      pariente =>{
        if(pariente != null){
          this.toastr.success("Datos de facturación se guardo","Éxito")
          this.economico.patchValue({
            id: pariente.aca_parentesco_id,
          })
          this.matriculaService.statusChange(this.idMatricula,this.idEstado).subscribe()
          this.emitGuardarDatos.emit(pariente.aca_parentesco_id)
        }
      }
    )

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-factura.component.ts